var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBbIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "93px",
    viewBox: "670 236 96 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(670.000000, 236.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.401104,3.71747903 C23.355472,3.71747903 3.79208832,22.8959533 3.79208832,46.4684879 C3.79208832,70.0410224 23.355472,89.2194967 47.401104,89.2194967 C71.446736,89.2194967 91.0101197,70.0410224 91.0101197,46.4684879 C91.0101197,22.8959533 71.446736,3.71747903 47.401104,3.71747903 M47.401104,92.9369758 C21.2622392,92.9369758 0,72.0930708 0,46.4684879 C0,20.8439049 21.2622392,0 47.401104,0 C73.5399688,0 94.802208,20.8439049 94.802208,46.4684879 C94.802208,72.0930708 73.5399688,92.9369758 47.401104,92.9369758",
    id: "Fill-25",
    fill: "#139CC2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#139CC2",
    points: "46.968149 50.1859669 92.4732089 50.1859669 92.4732089 46.4684879 46.968149 46.4684879"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    fill: "#139CC2",
    points: "0 50.1859669 22.7525299 50.1859669 22.7525299 46.4684879 0 46.4684879"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#139CC2",
    points: "76.1650261 78.3908183 11.8094952 15.3014816 14.4905016 12.673224 78.8460325 75.7625606"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#139CC2",
    points: "63.9432449 89.7000547 3.26983173 30.2203902 5.95083817 27.5921325 66.6242513 87.071797"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#139CC2",
    points: "46.968149 48.8341564 50.7602374 48.8341564 50.7602374 4.22440799 46.968149 4.22440799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#139CC2",
    points: "68.3173077 47.8540937 72.109396 47.8540937 72.109396 8.44881598 68.3173077 8.44881598"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#139CC2",
    points: "21.3491587 85.1302698 25.141247 85.1302698 25.141247 46.4684879 21.3491587 46.4684879"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBbIcon);
export default __webpack_public_path__ + "static/media/logo_bb_icon.cac17ab09e068fa49f4f27f72a0c8707.svg";
export { ForwardRef as ReactComponent };